import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getHoldReasonList: any = createAsyncThunk<any>(
	'getHoldReasonList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('holdReason', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addHoldReason: any = createAsyncThunk<any>(
	'addHoldReason',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post('/tenant-portal/holdReason', {
				params: data
			});
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateHoldReason: any = createAsyncThunk<any>(
	'updateHoldReason',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put('/holdReason', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getTemplateList: any = createAsyncThunk<any>(
	'getTemplateList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('holdReason/templates', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getTemplateListWithDetail: any = createAsyncThunk<any>(
	'getTemplateListWithDetail',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'holdReason/reasonTemplateWithDetails',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getTemplateDetail: any = createAsyncThunk<any>(
	'getTemplateDetail',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('holdReason/template', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const createIntegration: any = createAsyncThunk<any>(
	'createIntegration',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post('integrationCredential', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const updateIntegrationDetails: any = createAsyncThunk<any>(
	'updateIntegrationDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put('integrationCredential', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getIntegrationDetails: any = createAsyncThunk<any>(
	'getIntegrationDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('integrationCredential', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const testIntegrationConnection: any = createAsyncThunk<any>(
	'testIntegrationConnection',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'integrationCredential/testConnection',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getSapWarehouses: any = createAsyncThunk<any>(
	'getSapWarehouses',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'integrationCredential/sapWarehouses',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const triggerSapInventorySync: any = createAsyncThunk<any>(
	'triggerSapInventorySync',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/sapInventorySync/trigger',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue({
				...(typeof error?.response?.data === 'object' &&
				error?.response?.data !== null
					? error.response.data
					: { message: error?.response?.data }),
				statusCode: error?.response?.status
			});
		}
	}
);

export const reasonTemplateWithDetails: any = createAsyncThunk<any>(
	'reasonTemplateWithDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'holdReason/reasonTemplateWithDetails',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const sendMessage: any = createAsyncThunk<any>(
	'sendMessage',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/orderV2/sendReasonMessage',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getHoldReasonTemplateOptions: any = createAsyncThunk<any>(
	'getHoldReasonTemplateOptions',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('holdReasonTemplateOptions', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);